
import { Component, inject } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputComponent } from '../../../shared/components/ui/input/input.component';
import { PasswordInputComponent } from '../../../shared/components/ui/password-input/password-input.component';
import { Store } from '@ngrx/store';
import { login } from '../../../store/auth/auth.actions';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-login',
  imports: [CommonModule, ReactiveFormsModule, InputComponent, PasswordInputComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent {
  private store = inject(Store);
  private fb = inject(NonNullableFormBuilder);

  constructor() {}

  form = this.fb.group({
    identifier: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]],
  });

  get f() {
    return this.form.controls;
  }

  private errorMessages: Record<string, Record<string, string>> = {
    identifier: {
      required: 'L’identifiant est obligatoire',
      // email: 'Adresse email invalide',
    },
    password: {
      required: 'Le mot de passe est obligatoire',
      // minlength: 'Minimum 6 caractères',
    },
  };

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName);
    if (!control || !control.touched || control.valid) return null;

    const errors = this.errorMessages[controlName];
    if (!errors) return null;

    const firstErrorKey = Object.keys(control.errors!)[0];
    return errors[firstErrorKey] ?? null;
  }

  onSubmit() {
    if (this.form.valid) {
      const { identifier, password } = this.form.getRawValue();

      this.store.dispatch(login({ identifier, password }));
    } else {
      this.form.markAllAsTouched();
    }
  }
}
